import { useState, useEffect } from "react";
import "./styles/global.css";

import Navbar           from "./components/layout/Navbar";
import Footer           from "./components/layout/Footer";
import FloatingWhatsApp  from "./components/layout/FloatingWhatsApp";
import Hero             from "./sections/Hero";
import Objetivos        from "./sections/Objetivos";
import ProtoApp         from "./sections/ProtoApp";
import Locations        from "./sections/Locations";
import TeamPage         from "./pages/TeamPage";
import SuggestionsPage  from "./pages/SuggestionsPage";
import SnackCarousel    from "./sections/Carousel";
import CatalogPage      from "./pages/CatalogPage";
import ProductDetailModal from "./components/catalog/ProductDetailModal";
import AdminMasterPage from "./pages/AdminMasterPage";
import { DEFAULT_CATALOG_PRODUCTS } from "./constants/catalogData";
import { PAGE_HASHES, pageFromHash } from "./constants/pageHashes";
import { subscribeToCatalogProducts } from "./services/firebaseService";

export default function App() {
  const [currentPage, setCurrentPage] = useState(() => {
    if (window.location.pathname.replace(/\/$/, "") === "/admin") return "admin";
    return pageFromHash(window.location.hash);
  });

  const [homeModalProduct, setHomeModalProduct] = useState(null);
  const [homeProducts, setHomeProducts] = useState(DEFAULT_CATALOG_PRODUCTS);

  useEffect(() => subscribeToCatalogProducts((products) => setHomeProducts(products)), []);

  // Keep the visible opaque page code in sync with browser navigation.
  useEffect(() => {
    const handlePathChange = (event) => {
      if (window.location.pathname.replace(/\/$/, "") === "/admin") {
        setCurrentPage("admin");
        return;
      }
      setCurrentPage(pageFromHash(window.location.hash));
    };
    window.addEventListener("popstate", handlePathChange);
    return () => window.removeEventListener("popstate", handlePathChange);
  }, []);

  useEffect(() => {
    const handleHashChange = () => setCurrentPage(pageFromHash(window.location.hash));
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const navigateTo = (page) => {
    setCurrentPage(page);
    const nextHash = PAGE_HASHES[page] || "";
    if (window.location.hash !== nextHash) window.location.hash = nextHash;
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {currentPage === "admin" ? <AdminMasterPage /> : <>
      <Navbar currentPage={currentPage} onNavigate={navigateTo} />

      {currentPage === "catalog" ? (
        <main>
          <CatalogPage onNavigateHome={() => navigateTo("home")} />
        </main>
      ) : currentPage === "locations" ? (
        <main>
          <Locations />
        </main>
      ) : currentPage === "team" ? (
        <main>
          <TeamPage />
        </main>
      ) : currentPage === "suggestions" ? (
        <main>
          <SuggestionsPage />
        </main>
      ) : (
        <main>
          <Hero />
          <SnackCarousel
            products={homeProducts}
            onCatalog={() => navigateTo("catalog")}
            onProduct={(product) => setHomeModalProduct(product)}
          />
          <Objetivos />
          <ProtoApp />
        </main>
      )}

      <Footer onNavigate={navigateTo} />
      <FloatingWhatsApp />

      {/* Product Detail Modal when opened from Home Carousel */}
      {homeModalProduct && (
        <ProductDetailModal
          product={homeModalProduct}
          onClose={() => setHomeModalProduct(null)}
          onOpenManager={() => {
            setHomeModalProduct(null);
            navigateTo("catalog");
          }}
        />
      )}
      </>}
    </>
  );
}
